import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui';

export function HelpSearchBar() {
  return (
    <div className="bg-emerald-800 rounded-xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-emerald-400 blur-3xl"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 rounded-full bg-emerald-300 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto">
        <h2 className="text-2xl font-medium text-white mb-3">Xin chào, chúng tôi có thể giúp gì cho bạn?</h2>
        <p className="text-emerald-100 sm:text-sm text-xs mb-8">
          Tìm kiếm tài liệu hướng dẫn, quy trình vận hành và giải đáp thắc mắc.
        </p>

        <div className="relative max-w-xl mx-auto group">
          <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-slate-400 group-focus-within:text-emerald-600 transition-colors" />
          </div>
          <Input 
            type="text" 
            placeholder="Nhập từ khóa tìm kiếm (Ví dụ: Đổi mật khẩu, Lập đề xuất...)" 
            className="w-full pl-12 pr-4 h-14 rounded-full border-0 shadow-lg text-sm bg-white text-slate-800 placeholder:text-slate-400 focus-visible:ring-4 focus-visible:ring-emerald-500/30 transition-all"
          />
        </div>
      </div>
    </div>
  );
}
